<div class="card">
    <div class="card-body">

        <div class="">

            <table class="table-info">
                <tr>
                    <td>
                        <p class="table-row-title">NOMBRE ESTABLECIMIENTO:</p>
                    </td>
                    <td>
                        {{jardinPeriodo.jardin.jardin}}
                    </td>
                </tr>
                <tr class="table-tr-shadow">
                    <td>
                        <p class="table-row-title">CÓDIGO GESPARVU:</p>
                    </td>
                    <td> {{jardinPeriodo.jardin.rbd}}</td>
                </tr>
                <tr >
                    <td>
                        <p class="table-row-title">COMUNA:</p>
                    </td>
                    <td> {{jardinPeriodo.comuna.nombre}}</td>
                </tr>
                <tr class="table-tr-shadow">
                    <td>
                        <p class="table-row-title">REGIÓN:</p>
                    </td>
                    <td> {{jardinPeriodo.comuna.region.nombre}}</td>
                </tr>
                <tr>
                    <td>
                        <p class="table-row-title">DIRECCIÓN:</p>
                    </td>
                    <td> {{jardinPeriodo.direccion}}</td>
                </tr>
                <tr class="table-tr-shadow">
                    <td>
                        <p class="table-row-title">NOMBRE DIRECTORA:</p>
                    </td>
                    <td>{{jardinPeriodo.directorEncargado}}</td>
                </tr>
                <tr>
                    <td>
                        <p class="table-row-title">CORREO ELECTRÓNICO INSTITUCIONAL:</p>
                    </td>
                    <td> {{jardinPeriodo.directorCorreo}}</td>
                </tr>
            </table>


            <table class="table-info">
                <tr class="table-tr-shadow">
                    <td>
                        <p class="table-row-title">REPRESENTANTE LEGAL:</p>
                    </td>
                    <td>
                        <input type="text" value="{{jardinExtraData.representanteLegal}}" [(ngModel)]="jardinExtraData.representanteLegal" [disabled]="readonly">
                    </td>
                </tr>
                <tr>
                    <td>
                        <p class="table-row-title">TELÉFONO FIJO:</p>
                    </td>
                    <td>
                        <input type="text" value="{{jardinExtraData.telefonoFijo}}" [(ngModel)]="jardinExtraData.telefonoFijo" [disabled]="readonly">
                    </td>
                </tr>
                <tr class="table-tr-shadow">
                    <td>
                        <p class="table-row-title">MÓVIL INSTITUCIONAL:</p>
                    </td>
                    <td> 
                        <input type="text" value="{{jardinExtraData.movilInstitucional}}" [(ngModel)]="jardinExtraData.movilInstitucional" [disabled]="readonly">
                    </td>
                </tr>
                <tr>
                    <td>
                        <p class="table-row-title">NOMBRE DIRECTORA SUBROGANTE:</p>
                    </td>
                    <td>
                        <input type="text" value="{{jardinExtraData.directoraSubrogante}}" [(ngModel)]="jardinExtraData.directoraSubrogante" [disabled]="readonly">
                    </td>
                </tr>
                <tr class="table-tr-shadow">
                    <td>
                        <p class="table-row-title">CORREO ELECTRÓNICO INSTITUCIONAL:</p>
                    </td>
                    <td>
                        <input type="text" value="{{jardinExtraData.correoDirectoraSubrogante}}" [(ngModel)]="jardinExtraData.correoDirectoraSubrogante" [disabled]="readonly">
                    </td>
                </tr>
                <tr>
                    <td>
                        <p class="table-row-title">TELÉFONO FIJO:</p>
                    </td>
                    <td>
                        <input type="text" value="{{jardinExtraData.telefonoFijoDirectoraSubrogante}}" [(ngModel)]="jardinExtraData.telefonoFijoDirectoraSubrogante" [disabled]="readonly">
                    </td>
                </tr>
                <tr class="table-tr-shadow">
                    <td>
                        <p class="table-row-title">MÓVIL INSTITUCIONAL:</p>
                    </td>
                    <td>
                        <input type="text" value="{{jardinExtraData.movilInstitucionalDirectoraSubrogante}}" [(ngModel)]="jardinExtraData.movilInstitucionalDirectoraSubrogante" [disabled]="readonly">
                    </td>
                </tr>
                <tr>
                    <td>
                        <p class="table-row-title">CCORREO ELECTRÓNICO DEL ESTABLECIMIENTO:</p>
                    </td>
                    <td>
                        <input type="text" value="{{jardinExtraData.correoEstablecimientoDirectoraSubrogante}}" [(ngModel)]="jardinExtraData.correoEstablecimientoDirectoraSubrogante" [disabled]="readonly">
                    </td>
                </tr>
                <tr class="table-tr-shadow">
                    <td>
                        <p class="table-row-title">RESOLUCIÓN RECONOCIMIENTO OFICIAL:</p>
                    </td>
                    <td>
                        <div class="row">
                            <div class="col-sm-4">
                                <p >NÚMERO:</p>
                                <input type="number" value="{{jardinExtraData.rroNumero}}" [(ngModel)]="jardinExtraData.rroNumero" [disabled]="readonly" style="margin-top: opx;">
                        
                            </div>
                            <div class="col-sm-4">
                                <p >FECHA:</p>
                                <div class="input-group p-2">
                                    <div class="input-group-append">
                                        <button class="btn btn-calendar" (click)="d1.toggle()" style="width: 40px;padding: 12px 12px;" type="button" [disabled]="readonly">
                                            <i class="fas fa-calendar-alt"></i>
                                        </button>
                                    </div>
                                    <input class="form-control input-fecha" [ngClass]="fechaClass" style="padding: 6px 12px;" name="fechaData" [(ngModel)]="this.fechaData" ngbDatepicker #d1="ngbDatepicker" (ngModelChange)="change()" readonly>
                                    <button class="btn btn-calendar-clear" (click)="clearDate()" type="button" [disabled]="readonly"> 
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <p >RBD:</p>
                                <input type="number" value="{{jardinExtraData.rroRbd}}" [(ngModel)]="jardinExtraData.rroRbd" [disabled]="readonly" style="margin-top: opx;">
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>